module.exports = __webpack_public_path__ + "img/uplify-plus-pareto-logo.00f29590.svg";